// src/components/Layout/Footer.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <footer className="bg-[#005005] text-white mt-16">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section - Always visible */}
          <div>
            <h4 className="text-xl font-bold mb-4 flex items-center gap-2">
              <i className="fas fa-graduation-cap"></i> GradPath
            </h4>
            <p className="text-gray-300">
              Bridging the gap between graduates and opportunities.
            </p>
            <div className="flex gap-4 mt-4 justify-center md:justify-start">
              <a
                href="https://www.linkedin.com/company/gradpath-south-africa/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white text-2xl transition-colors"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin"></i>
              </a>
              <a
                href="https://www.instagram.com/gradpathza/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white text-2xl transition-colors"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="#"
                className="text-gray-300 hover:text-white text-2xl transition-colors"
                onClick={(e) => e.preventDefault()}
                aria-label="Twitter"
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="#"
                className="text-gray-300 hover:text-white text-2xl transition-colors"
                onClick={(e) => e.preventDefault()}
                aria-label="Facebook"
              >
                <i className="fab fa-facebook"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/jobs" className="text-gray-300 hover:text-white">
                  Jobs
                </Link>
              </li>
              <li>
                <Link
                  to="/cv-creator"
                  className="text-gray-300 hover:text-white"
                >
                  CV Creator
                </Link>
              </li>
              <li>
                <Link
                  to="/cover-letter"
                  className="text-gray-300 hover:text-white"
                >
                  Cover Letter
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-white">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/for-recruiters" className="text-gray-300 hover:text-white">
                  Hire Talent
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal - Hidden on mobile */}
          {!isMobile && (
            <div>
              <h4 className="text-lg font-semibold mb-4">Legal</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/privacy" className="text-gray-300 hover:text-white">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="text-gray-300 hover:text-white">
                    Terms & Conditions
                  </Link>
                </li>
                <li>
                  <Link to="/cookie-policy" className="text-gray-300 hover:text-white">
                    Cookie Policy
                  </Link>
                </li>
                <li>
                  <Link to="/popia-notice" className="text-gray-300 hover:text-white">
                    POPIA Notice
                  </Link>
                </li>
                <li>
                  <Link to="/disclaimer" className="text-gray-300 hover:text-white">
                    Disclaimer
                  </Link>
                </li>
                <li>
                  <Link to="/paia" className="text-gray-300 hover:text-white">
                    PAIA Manual
                  </Link>
                </li>
                <li>
                  <Link to="/recruiter-terms" className="text-gray-300 hover:text-white">
                    Recruiter Terms
                  </Link>
                </li>
                <li>
                  <Link to="/candidate-terms" className="text-gray-300 hover:text-white">
                    Candidate Terms
                  </Link>
                </li>
              </ul>
            </div>
          )}

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white">
                  Contact Us
                </Link>
              </li>
              <li>
                <p className="text-gray-300">
                  <i className="fas fa-envelope mr-2"></i> info@gradpath.co.za
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-gray-400">
          <p>&copy; 2026 GradPath. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;